import { action, thunk } from 'easy-peasy';
import { getLinkolnEmails } from '../services/LinkolnEmails';

const LinkolnEmailsModel = {
  linkoln_emails: [],
  showLinkolnEmails: action((state, new_linkoln_emails) => {
    state.linkoln_emails = new_linkoln_emails || [];
  }),
  getLinkolnEmails: thunk(async (actions, domain, {getStoreState}) => {
    if (!domain) {
      let state = getStoreState();
      domain = state.current_domain.domain;
    }
    let linkoln_emails = await getLinkolnEmails(domain);
    actions.showLinkolnEmails(linkoln_emails);
  })
};

export default LinkolnEmailsModel;
